import Vue from "vue";
import actions from "./actions";

import {
  errorMutations,
  loadingMutations,
  replaceOrSetArrayObjectsValue,
  resetErrorsAndLoading,
  setter,
  getter
} from "@/store/utils";

import {
  FETCH_TAGS_LIST,
  FETCH_FILTERED_TAGS_LIST,
  FETCH_FORM_TAGS_LIST,
  FETCH_TAGS_PER_PAGE_LIST,
  FETCH_TAG,
  UPDATE_TAGS,
  UPDATE_SELECTED_TAGS,
  CREATE_TAG,
  DELETE_TAG,
  DELETE_TAGS
} from "./types";

const state = {
  tags: [],
  isLoading: false,

  selectedTags: [],

  filteredTags: [],
  isFilteredTagsLoading: false,

  formTags: [],
  isFormTagsLoading: false,

  tagsPerPage: [],
  isTagsPerPageLoading: false,

  errors: null
};

const getters = {
  getTag: state => id => {
    const res = state.tags.filter(tag => tag.id === id);

    if (res.length) {
      return res[0];
    }
  },

  tags: state => key => {
    if (!key) {
      key = "tags";
    }
    return state[key];
  },

  isLoading: getter("isLoading"),
  isTagsPerPageLoading: getter("isTagsPerPageLoading"),
  isFilteredTagsLoading: getter("isFilteredTagsLoading"),
  isFormTagsLoading: getter("isFormTagsLoading")
};

const mutations = {
  [CREATE_TAG.success](state, { payload }) {
    const newObj = [...state.tags, payload];
    // setter("tags", newObj)(state);
    state.isFilteredTagsLoading = false;
    state.isFormTagsLoading = false;
    resetErrorsAndLoading(state);
  },

  [FETCH_TAGS_LIST.success](state, { payload }) {
    setter("tags", payload)(state);
    resetErrorsAndLoading(state);
  },

  [FETCH_FILTERED_TAGS_LIST.success](state, { payload }) {
    setter("filteredTags", payload)(state);
    setter("isFilteredTagsLoading", false)(state);
    resetErrorsAndLoading(state);
  },

  [FETCH_FORM_TAGS_LIST.success](state, { payload }) {
    setter("formTags", payload)(state);
    setter("isFormTagsLoading", false)(state);
    resetErrorsAndLoading(state);
  },

  [FETCH_TAGS_PER_PAGE_LIST.success](state, { payload }) {
    setter("tagsPerPage", payload)(state);
    setter("isTagsPerPageLoading", false)(state);
    resetErrorsAndLoading(state);
  },

  [FETCH_TAG.success](state, { payload }) {
    replaceOrSetArrayObjectsValue(state, "tags", "id", payload.id, payload);
    resetErrorsAndLoading(state);
  },

  [UPDATE_TAGS](state, { payload }) {
    if (state.tags.indexOf(payload) === -1) {
      state.tags.push(payload);
    }
    if (state.formTags.indexOf(payload) === -1) {
      state.formTags.push(payload);
    }
  },

  [UPDATE_SELECTED_TAGS](state, { payload }) {
    state.selectedTags = payload;
  },

  [DELETE_TAG.success](state, { payload }) {
    const updTags = state.tags.filter(tag => tag.id !== payload);
    setter("tags", updTags)(state);

    const updFilteredTags = state.filteredTags.filter(
      tag => tag.id !== payload
    );
    setter("filteredTags", updFilteredTags)(state);

    const updSelectedTags = state.selectedTags.filter(
      tag => tag.id !== payload
    );
    setter("selectedTags", updSelectedTags)(state);

    const updFormTags = state.formTags.filter(tag => tag.id !== payload);
    setter("formTags", updFormTags)(state);

    const updTagsPerPage = state.tagsPerPage.filter(tag => tag.id !== payload);
    setter("tagsPerPage", updTagsPerPage)(state);
    resetErrorsAndLoading(state);
  },

  [DELETE_TAGS.success](state, { payload }) {
    const updTags = state.tags.filter(tag => !payload.includes(tag.id));
    setter("tags", updTags)(state);

    const updFilteredTags = state.filteredTags.filter(
      tag => !payload.includes(tag.id)
    );
    setter("filteredTags", updFilteredTags)(state);

    const updSelectedTags = state.selectedTags.filter(
      tag => !payload.includes(tag.id)
    );
    setter("selectedTags", updSelectedTags)(state);

    const updFormTags = state.formTags.filter(tag => !payload.includes(tag.id));
    setter("formTags", updFormTags)(state);

    const updTagsPerPage = state.tagsPerPage.filter(
      tag => !payload.includes(tag.id)
    );
    setter("tagsPerPage", updTagsPerPage)(state);
    resetErrorsAndLoading(state);
  },

  ...loadingMutations([
    CREATE_TAG.request,
    FETCH_TAGS_LIST.request,
    FETCH_TAG.request,
    DELETE_TAG.request,
    DELETE_TAGS.request
  ]),

  ...errorMutations([
    FETCH_TAGS_LIST.error,
    FETCH_TAG.error,
    CREATE_TAG.error,
    DELETE_TAG.error,
    DELETE_TAGS.error
  ]),

  [CREATE_TAG.request](state, { payload }) {
    state.isFilteredTagsLoading = true;
    state.isFormTagsLoading = true;
  },

  // termporary sepaparate loading
  // for different tags state cells
  [FETCH_FILTERED_TAGS_LIST.request](state, { payload }) {
    setter("isFilteredTagsLoading", true)(state);
  },

  [FETCH_FORM_TAGS_LIST.request](state, { payload }) {
    setter("isFormTagsLoading", true)(state);
  },

  [FETCH_TAGS_PER_PAGE_LIST.request](state, { payload }) {
    setter("isTagsPerPageLoading", true)(state);
  },

  ...loadingMutations([
    // FETCH_TAGS_LIST.request,
    // FETCH_TAG.request,
    // FETCH_FORM_TAGS_LIST.request,
    // FETCH_FILTERED_TAGS_LIST.request
  ]),

  ...errorMutations([FETCH_TAGS_LIST.error, FETCH_TAG.error, CREATE_TAG.error])
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
